import React from "react";

const Charges = ( { formikProps } ) =>
{
  <p>Charges</p>;
};

export { Charges };
